import { useEffect, useRef, useCallback } from "react";

export const useMidnightReset = (onReset: () => void, enabled: boolean) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const scheduleReset = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setHours(24, 0, 0, 0);

    const msUntilMidnight = tomorrow.getTime() - now.getTime();

    timerRef.current = setTimeout(() => {
      onReset();
      scheduleReset(); // Reschedule for next midnight
    }, msUntilMidnight);
  }, [onReset]);

  useEffect(() => {
    if (enabled) {
      scheduleReset();
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [enabled, scheduleReset]);

  return { scheduleReset };
};
